import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import req from "../../axios/interceptedAxiosInstance";

export const getUserProfileImage = createAsyncThunk(
  "user/profile/getuserProfileImage",
  async () => {
    try {
      const response = await req.get("profile/fetch");
      return response.data.data.profile_image;
    } catch (error) {
      console.log(error);
    }
  }
);

const initialState = {
  profile_image: "",
};

const profileSlice = createSlice({
  name: "profile",
  initialState,
  reducers: {
    updateProfilePicture: (state, action) => {
      return {
        ...state,
        profile_image: action.payload,
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getUserProfileImage.fulfilled, (state, action) => {
      state.profile_image = action.payload;
    });
  },
});
export const { updateProfilePicture } = profileSlice.actions;

export default profileSlice.reducer;
